(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecofox-compare-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('ecofox-compare')) return;

  class EcofoxCompare extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-efc-tab]'));
      this.dotBtns = Array.from(this.querySelectorAll('[data-efc-dot]'));
      this.panels = Array.from(this.querySelectorAll('.efc__panel'));
      this.start = parseFloat(this.dataset.start) || 50;
      this.index = 0;
      this.touched = false;

      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.select(i));
        t.addEventListener('keydown', (e) => {
          let n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % this.tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
          if (n !== null) { e.preventDefault(); this.select(n); this.tabs[n].focus(); }
        });
      });
      this.dotBtns.forEach((d, i) => d.addEventListener('click', () => this.select(i)));
      this.panels.forEach((p) => this.initCard(p.querySelector('.efc__card')));

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.drawActive());
        this.ro.observe(this);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.drawActive());
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.drawActive(), { once: true });
      });

      this.onBlockSelect = (e) => {
        const i = this.panels.findIndex((p) => p.id === 'efc-panel-' + e.detail.blockId);
        if (i > -1) this.select(i);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      if (this.dataset.intro === 'true' && 'IntersectionObserver' in window &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) {
            this.io.disconnect();
            setTimeout(() => this.introHint(), 400);
          }
        }, { threshold: 0.5 });
        this.io.observe(this);
      }

      requestAnimationFrame(() => this.drawActive());
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(i) {
      if (i === this.index && this.panels[i] && !this.panels[i].hidden) return;
      this.index = i;
      this.tabs.forEach((t, j) => {
        const on = j === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.dotBtns.forEach((d, j) => d.classList.toggle('is-active', j === i));
      this.panels.forEach((p, j) => {
        p.hidden = j !== i;
        p.classList.toggle('is-active', j === i);
      });
      requestAnimationFrame(() => this.drawActive());
    }

    initCard(card) {
      if (!card) return;
      const handle = card.querySelector('.efc__handle');
      let dragging = false;
      const fromX = (x) => {
        const r = card.getBoundingClientRect();
        this.setPos(card, ((x - r.left) / r.width) * 100);
      };
      card.addEventListener('pointerdown', (e) => {
        if (e.button !== 0) return;
        dragging = true;
        this.touched = true;
        card.classList.add('is-dragging');
        try { card.setPointerCapture(e.pointerId); } catch (err) {}
        fromX(e.clientX);
      });
      card.addEventListener('pointermove', (e) => { if (dragging) fromX(e.clientX); });
      const end = () => { dragging = false; card.classList.remove('is-dragging'); };
      card.addEventListener('pointerup', end);
      card.addEventListener('pointercancel', end);
      card.addEventListener('lostpointercapture', end);

      handle.addEventListener('keydown', (e) => {
        const cur = card._pos;
        const step = e.shiftKey ? 10 : 2;
        let v = null;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') v = cur - step;
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') v = cur + step;
        if (e.key === 'Home') v = 0;
        if (e.key === 'End') v = 100;
        if (v !== null) { e.preventDefault(); this.touched = true; this.setPos(card, v); }
      });

      this.setPos(card, this.start);
    }

    setPos(card, v) {
      v = Math.max(0, Math.min(100, v));
      card._pos = v;
      card.style.setProperty('--pos', v + '%');
      const h = card.querySelector('.efc__handle');
      if (h) h.setAttribute('aria-valuenow', Math.round(v));
    }

    introHint() {
      const panel = this.panels[this.index];
      const card = panel && panel.querySelector('.efc__card');
      if (!card || this.touched) return;
      const s = this.start;
      const keys = [s, s - 12, s + 12, s];
      const seg = 550;
      const t0 = performance.now();
      const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
      const tick = (now) => {
        if (this.touched) return;
        const el = now - t0;
        const i = Math.min(Math.floor(el / seg), keys.length - 2);
        const t = Math.min(1, (el - i * seg) / seg);
        this.setPos(card, keys[i] + (keys[i + 1] - keys[i]) * ease(t));
        if (el < seg * (keys.length - 1)) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    drawActive() {
      const p = this.panels[this.index];
      if (p) this.draw(p.querySelector('.efc__card'));
    }

    draw(card) {
      if (!card) return;
      const cr = card.getBoundingClientRect();
      if (!cr.width) return;
      card.querySelectorAll('.efc__callout').forEach((c) => {
        const label = c.querySelector('.efc__label');
        const dot = c.querySelector('.efc__dot');
        const path = c.querySelector('.efc__line path');
        const isCon = c.classList.contains('efc__callout--con');
        const lr = label.getBoundingClientRect();
        const dr = dot.getBoundingClientRect();
        const dx = dr.left + dr.width / 2 - cr.left;
        const dy = dr.top + dr.height / 2 - cr.top;
        const ly = lr.top + lr.height / 2 - cr.top;
        const ex = isCon ? lr.right - cr.left : lr.left - cr.left;
        const overlap = isCon ? dx < ex + 18 : dx > ex - 18;
        c.classList.toggle('is-collapsed', overlap);
        if (overlap) { path.setAttribute('d', ''); return; }
        const dir = isCon ? 1 : -1;
        const bend = Math.min(16, Math.abs(dx - ex) / 3, Math.abs(dy - ly) + 6);
        path.setAttribute('d', 'M' + ex + ' ' + ly + ' H' + (dx - dir * bend) + ' L' + dx + ' ' + dy);
      });
    }
  }

  customElements.define('ecofox-compare', EcofoxCompare);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecofox-reset-essentials"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!customElements.get('ecofox-reset')) {
    class EcofoxReset extends HTMLElement {
      connectedCallback() {
        this.btns = Array.from(this.querySelectorAll('[data-plan-btn]'));
        this.btns.forEach((b) => b.addEventListener('click', () => this.show(b.dataset.planBtn)));
      }
      show(n) {
        this.btns.forEach((b) => {
          const on = b.dataset.planBtn === n;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.querySelectorAll('[data-plan]').forEach((el) => { el.hidden = el.dataset.plan !== n; });
      }
    }
    customElements.define('ecofox-reset', EcofoxReset);
  }
  if (!window.__efrCheckout) {
    window.__efrCheckout = true;
    // Adds the selected bundle on its Subscribe & Save plan and goes straight to checkout.
    // Uses a native form post (not fetch) so subscription apps that patch fetch can't drop the plan.
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-efr-checkout]');
      if (!link || link.classList.contains('is-loading')) return;
      const root = document.getElementById('efr-' + link.dataset.efrCheckout);
      const active = root && root.querySelector('[data-plan-btn].is-active');
      if (!active || !active.dataset.variant) return;
      e.preventDefault();
      link.classList.add('is-loading');
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const form = document.createElement('form');
      form.method = 'post';
      form.action = base + 'cart/add';
      form.hidden = true;
      const fields = { id: active.dataset.variant, quantity: '1', return_to: base + 'checkout' };
      if (active.dataset.sellingPlan) fields.selling_plan = active.dataset.sellingPlan;
      Object.keys(fields).forEach((k) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = k;
        input.value = fields[k];
        form.appendChild(input);
      });
      document.body.appendChild(form);
      HTMLFormElement.prototype.submit.call(form);
    });
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('.efr__btn.is-loading').forEach((el) => el.classList.remove('is-loading'));
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
